import {
  IBatchPaperToCollection,
  ICollection,
} from "@/interfaces/bundle.interface";
import { atom, RecoilState } from "recoil";

export const collectionState: RecoilState<Partial<ICollection>> = atom({
  key: "collection",
  default: {},
});

export type ICollections = {
  count: number;
  results: ICollection[];
};

export const collectionsState: RecoilState<ICollections> = atom({
  key: "collections",
  default: { count: 0, results: [] },
});

export const batchUpdateCollectionState: RecoilState<
  IBatchPaperToCollection[]
> = atom({
  key: "batchPaperToCollection",
  default: [],
});

export const batchUpdateSelectedState: RecoilState<string[]> = atom({
  key: "batchSelected",
  default: [],
});

export const showCollectorCommentsState: RecoilState<{
  userId: string;
  show: boolean;
}> = atom({
  key: "showCollectorCommentsState",
  default: { userId: "", show: false },
});
